function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Prospects_svg__16_a",
  x1: "0%",
  x2: "100%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#7793FF"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#1877F2"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#Prospects_svg__16_a)",
  d: "M8 0h34a8 8 0 018 8v34a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z"
}), React.createElement("path", {
  fill: "#CCE4FE",
  d: "M41.514 25.695h.09l-3.402-6.469A5.075 5.075 0 0035.58 17a4.902 4.902 0 00-4.55-3 4.903 4.903 0 00-4.505 3.07c-.95-.48-2.07-.48-3.02 0A4.9 4.9 0 0018.966 14a4.9 4.9 0 00-4.54 3.07 5.062 5.062 0 00-2.474 2.18l-2.65 4.858a7.647 7.647 0 00.11 8.69 7.572 7.572 0 008.146 2.935 7.612 7.612 0 005.62-7.361c.002-.512-.048-1.023-.148-1.525a7.555 7.555 0 00-.261-.925 2.48 2.48 0 012.23-1.401c.95 0 1.816.544 2.231 1.401a7.6 7.6 0 00-.26.928 7.753 7.753 0 00-.115 2.223 7.615 7.615 0 005.006 6.483 7.566 7.566 0 007.963-1.834 7.644 7.644 0 001.69-8.027zM15.48 33.5a4.999 4.999 0 115.019-5 5.013 5.013 0 01-5.019 5zm19.02 0a5.004 5.004 0 01-4.793-6.432A5.027 5.027 0 0134.5 23.5a4.962 4.962 0 013.627 1.569h.02l.26.317a5.003 5.003 0 01.597 5.29 4.98 4.98 0 01-4.504 2.824z"
}));

var SvgProspects = function SvgProspects(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2);
};

export default SvgProspects;